"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEPARATOR_MARGIN_AT_BP = exports.GTR = exports.GRID_GAP_DEFAULT = exports.GRID_DIVIDER_SIZE_DEFAULT = exports.GRID_COLUMNS_DEFAULT = exports.CONTENT_OUTER_WIDTH = exports.CONTENT_INNER_WIDTH = exports.CONTAINER_PADDING_VERTICAL_AT_BP = exports.CONTAINER_PADDING_HORIZONTAL_AT_BP = exports.CONTAINER_GRID_GAP_AT_BP = exports.BREAKPOINT = void 0;
const GTR = exports.GTR = {
  XXS: '4px',
  XS: '8px',
  S: '16px',
  M: '24px',
  L: '32px',
  XL: '48px',
  XXL: '72px'
};
const CONTENT_OUTER_WIDTH = exports.CONTENT_OUTER_WIDTH = '1296px';
const CONTENT_INNER_WIDTH = exports.CONTENT_INNER_WIDTH = '1200px';
const BREAKPOINT = exports.BREAKPOINT = {
  XS: 300,
  S: 648,
  M: 964,
  L: 1296
};
const GRID_GAP_DEFAULT = exports.GRID_GAP_DEFAULT = 'M';
const GRID_COLUMNS_DEFAULT = exports.GRID_COLUMNS_DEFAULT = 12;
const GRID_DIVIDER_SIZE_DEFAULT = exports.GRID_DIVIDER_SIZE_DEFAULT = '1px';
const CONTAINER_PADDING_HORIZONTAL_AT_BP = exports.CONTAINER_PADDING_HORIZONTAL_AT_BP = {
  XS: 'M',
  S: 'M',
  M: 'L',
  L: 'XL',
  XL: 'XL'
};
const CONTAINER_PADDING_VERTICAL_AT_BP = exports.CONTAINER_PADDING_VERTICAL_AT_BP = {
  XS: 'L',
  S: 'L',
  M: 'XL',
  L: 'XXL',
  XL: 'XXL'
};
const CONTAINER_GRID_GAP_AT_BP = exports.CONTAINER_GRID_GAP_AT_BP = {
  XS: GRID_GAP_DEFAULT,
  S: GRID_GAP_DEFAULT,
  M: 'L',
  L: 'XL',
  XL: 'XL'
};
const SEPARATOR_MARGIN_AT_BP = exports.SEPARATOR_MARGIN_AT_BP = {
  XS: 'M',
  S: 'M',
  M: 'L',
  L: 'XL',
  XL: 'XL'
};